import { render } from "./TheCut.vue?vue&type=template&id=3a83f2c1&scoped=true"
import script from "./TheCut.vue?vue&type=script&lang=js"
export * from "./TheCut.vue?vue&type=script&lang=js"

import "./TheCut.vue?vue&type=style&index=0&id=3a83f2c1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a83f2c1"]])

export default __exports__